import React, { useEffect } from "react";

const useOutsideHeaderMenuClick = (
  onClickShowMainMenu: any,
  onClickShowProfileMenu: any,
  containerRef: any,
  clickRef: any,
  menuRef: any,
  burgerRef: any,
  windowWidth: number,
  isProfileMenuOpen: boolean
) => {
  useEffect(() => {
    function onOutsideClick(event: any) {
      if (windowWidth > 768) {
        if (clickRef?.current?.contains(event.target)) {
          onClickShowProfileMenu(!isProfileMenuOpen);
        } else if (
          isProfileMenuOpen &&
          !containerRef?.current?.contains(event.target)
        ) {
          onClickShowProfileMenu(false);
        }
      } else {
        if (menuRef?.current?.style?.display == "block") {
          if (!menuRef?.current?.contains(event.target)) {
            onClickShowMainMenu(false);
            onClickShowProfileMenu(false);
          } else if (clickRef?.current?.contains(event.target)) {
            onClickShowProfileMenu(!isProfileMenuOpen);
          }
        } else {
          if (burgerRef?.current?.contains(event.target)) {
            if (!isProfileMenuOpen) {
              onClickShowMainMenu(true);
              onClickShowProfileMenu(true);
            } else {
              onClickShowMainMenu(false);
              onClickShowProfileMenu(false);
            }
          }
        }
      }
    }
    document.addEventListener("mousedown", onOutsideClick);
    return () => {
      document.removeEventListener("mousedown", onOutsideClick);
    };
  }, [windowWidth, isProfileMenuOpen]);
};

export default useOutsideHeaderMenuClick;
